import {dispatchAction} from './store';
export default dispatchAction;


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/dispatchAction.js